import { SVGProps } from 'react';

function PaperPlaneIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M20.9609 1.94531L18.4609 18.1562C18.4219 18.5469 18.1875 18.8984 17.8359 19.0938C17.6406 19.1719 17.4453 19.25 17.2109 19.25C17.0547 19.25 16.8984 19.2109 16.7422 19.1328L11.9766 17.1406L9.98438 20.1094C9.82812 20.3828 9.55469 20.5 9.28125 20.5C8.85156 20.5 8.5 20.1484 8.5 19.7188V15.9688C8.5 15.6562 8.57812 15.3828 8.73438 15.1875L17.25 4.25L5.76562 14.6016L1.74219 12.9219C1.3125 12.7266 1 12.3359 1 11.8281C0.960938 11.2812 1.19531 10.8906 1.625 10.6562L19.125 0.695312C19.5156 0.460938 20.0625 0.460938 20.4531 0.734375C20.8438 1.00781 21.0391 1.47656 20.9609 1.94531Z" fill="#0B409C" />
    </svg>
  );
}

export default PaperPlaneIcon;
